module.exports = __webpack_public_path__ + "static/media/bill_gates.jpg_1544913167347.b40219b7.jpg";